<template>
  <form
    @submit.prevent="handleSubmit"
    name="company"
    class="clearfix">
    <div class="col-md-6 padding-off">
      <div class="col-md-12">
        <h4 class="title-manage-account">Dados empresariais</h4>
      </div>
      <fieldset :disabled="!canEdit">
        <div class="col-md-6">
          <!-- CNPJ -->
          <input-field
            :readonly="true"
            :submitted="submitted"
            :field.sync="form.document_number"
            :required="true"
            :mask="['##.###.###/####-##']"
            label="CNPJ"
            type="text"
            name="document_number"
            validate="required"></input-field>
          <!-- / CNPJ -->
        </div>
        <div class="col-md-6">
          <!-- Telefone fixo -->
          <input-field
            :submitted="submitted"
            :field.sync="form.phone"
            :required="true"
            :mask="['(##) ####-####', '(##) #####-####']"
            label="Telefone"
            type="tel"
            name="phone"
            validate="required"></input-field>
          <!-- / Telefone fixo -->
        </div>
        <div class="col-md-12">
          <!-- Razão Social -->
          <input-field
            :submitted="submitted"
            :field.sync="form.name"
            :required="true"
            label="Razão Social"
            type="text"
            name="name"
            validate="required"></input-field>
          <!-- / Razão Social -->
        </div>
        <div class="col-md-12 mb-20">
          <!-- Nome fantasia -->
          <input-field
            :submitted="submitted"
            :field.sync="form.fantasy_name"
            label="Nome fantasia"
            type="text"
            name="fantasy_name"></input-field>
          <!-- / Nome fantasia -->
        </div>
        <div class="col-sm-12 mb-20 clearfix">
          <small>*Campos obrigatórios</small>
        </div>
      </fieldset>
    </div>
    <div class="col-md-6 padding-off">
      <fieldset :disabled="!canEdit">
        <address-form
          title="Endereço Empresarial"
          :submitted="submitted"
          :form.sync="form.address"></address-form>
      </fieldset>
    </div>
    <div
      v-if="canEdit"
      class="clearfix col-sm-12 padding-off mt-20 mb-20">
      <!-- Parent Action -->
      <slot :handleParentAction="() => $emit('handleParentAction')"></slot>
      <!-- // Parent Action -->
      <div class="col-xs-6">
        <button
          :disabled="disabled"
          type="submit"
          class="btn-blue btn-block btn-extra-large">
          Salvar
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import InputField from '@/components/fields/InputField'
import AddressForm from '@/components/forms/AddressForm'

export default {
  props: {
    canEdit: {
      type: Boolean,
      default: () => false
    },
    id: {
      type: String,
      default: () => null
    }
  },
  components: {
    InputField,
    AddressForm
  },
  data() {
    return {
      form: {
        id: null,
        name: null,
        fantasy_name: null,
        document_number: null,
        phone: null,
        address: {
          id: null,
          street: null,
          number: null,
          complement: null,
          neighborhood: null,
          city: null,
          province: null,
          country_id: null,
          zip_code: null
        }
      },
      submitted: false,
      disabled: false
    }
  },
  mounted () {
    this.getCompanies(this.id)
      .then(this.handleForm)
  },
  computed: {
    ...mapState('companies', ['results'])
  },
  methods: {
    ...mapActions('companies', [
      'getCompanies',
      'patchCompany'
    ]),
    handleForm (data) {
      this.form = { ...this.form, ...data }
      if (Object.prototype.hasOwnProperty.call(data, 'address')) {
        this.form = {
          ...this.form,
          address: data.address[0]
        }
      }
    },
    handleSubmit () {
      this.$validator.validate().then(valid => {
        this.submitted = true

        if (valid) {
          this.disabled = false
          this.patchCompany(this.form)
            .then(this.handleParent)
            .catch(this.handleParent)
        }
      }).catch(() => {
        /**/
        this.submitted = false
      })
    },
    handleParent () {
      if (this.$listeners && this.$listeners.handleParentAction) {
        this.$emit('handleParentAction')
      }
      this.submitted = false
      this.disabled = false

      /* UPDATE FORM */
      this.getCompanies(this.id)
        .then(this.handleForm)
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/scss/components/forms/ScopedForms';
</style>
